import { useState } from 'react';
import { supabase } from '../lib/supabase';

const BUCKET = 'questionarios-anexos';

// Upload e leitura dos questionários respondidos fora do app (PDF/foto),
// no mesmo padrão de useExameResultado: bucket privado + URL assinada.
export function useQuestionarioAnexo() {
  const [uploading, setUploading] = useState(false);

  async function uploadAnexo(alunaId, tipo, file) {
    setUploading(true);
    try {
      const ext = file.name.split('.').pop();
      const path = `${alunaId}/${tipo}/${Date.now()}.${ext}`;
      const { error } = await supabase.storage
        .from(BUCKET)
        .upload(path, file, { contentType: file.type });
      if (error) throw error;
      return { path, nomeArquivo: file.name, tipo: file.type, enviadoEm: new Date().toISOString() };
    } finally {
      setUploading(false);
    }
  }

  async function abrirAnexo(path) {
    const { data, error } = await supabase.storage.from(BUCKET).createSignedUrl(path, 60);
    if (error) throw error;
    window.open(data.signedUrl, '_blank', 'noopener');
  }

  async function removerAnexo(path) {
    await supabase.storage.from(BUCKET).remove([path]);
  }

  return { uploadAnexo, abrirAnexo, removerAnexo, uploading };
}
